import { Flex, Tag } from 'antd';
import { useMemo } from 'react';

import type { BottomContentType } from '@pages/Clients/NewClientsList/components/MultiFilter/types';

import { useNewClientsListContext } from '@pages/Clients/NewClientsList/context/useNewClientsListContext';
import { PF } from '@pages/Clients/NewClientsList/data/constants';

export const ServicesSelected: BottomContentType = ({ id }) => {
  const { filtersMap, onChangeServices } = useNewClientsListContext();

  const { services } = filtersMap.get(id)!;

  const servicesWithoutCategories = useMemo(
    () => services.filter((service) => !service.includes('category-')),
    [services]
  );

  if (services.length === 0) {
    return null;
  }

  return (
    <Flex className={`${PF}__tags`} wrap="wrap" gap="4px">
      <Tag
        className={`${PF}__tag`}
        closable
        onClose={() => onChangeServices([], id)}
      >
        Выбрано: {servicesWithoutCategories.length} услуг
        {servicesWithoutCategories.length === 1
          ? 'a'
          : servicesWithoutCategories.length > 4
          ? ''
          : 'и'}
      </Tag>
    </Flex>
  );
};
